import PaintProcurementConfigWorkspace from '../../placeholders/PaintProcurementConfigWorkspace';

export default PaintProcurementConfigWorkspace;
